import { AbstractService } from "./abstract.service";

export class CategoryService extends AbstractService {
  static get entity() {
    return "proxy-gateway/gw-core/category";
  }

  static get URL_GATEWAY() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }

  static async getList(_params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/get-list`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async countGetList(_params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/count`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async addCate(_params) {
    try {
      const response = await this.callApi().post(`nsh/category/categories`, _params);
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async updateCate(itemId, _params) {
    try {
      const response = await this.callApi().patch(
        `${this.entity}/${itemId}`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async getItemIdCate(itemId) {
    try {
      const response = await this.callApi().get(`${this.entity}/${itemId}`);
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async deleteCate(itemId, _params) {
    try {
      const response = await this.callApi().delete(
        `${this.entity}/${itemId}/archive`,
        { data: _params }
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async changeParentCate(_params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/change-parent`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async createCategory(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/nsh/category/categories`, params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
}
